import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideMetadataFieldOption } from './ride-metadata-field-option';

@inheritSerialization(AbstractModel)
export class RideMetadataField extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  required: boolean;

  @autoserialize
  strict: boolean;

  @autoserialize
  systemDetermined: boolean;

  @autoserialize
  active: boolean;

  @autoserializeAs(RideMetadataFieldOption)
  rideMetadataFieldOptions: Array<RideMetadataFieldOption>;
}
